module.exports = gigya;